<template>
  <div class="word-container">
    <div class="word-and-btn">
      <span class="word">{{ wordName }}</span>
      <van-button
        class="new-word-btn"
        :class="{ 'sel-new-word-btn': item.isAddToNewWord }"
        plain
        round
        type="info"
        @click="action_newword()"
        >{{ btnword }}
      </van-button>
    </div>
    <div class="pronounce-wrapper">
      <div
        v-if="word.ukSpeech"
        class="pronounce-btn"
        :class="{
          'pronounce-btn-sel': word.ukSpeech && word.ukSpeech == curAudioUrl,
        }"
        @click="action_pronounce(word.ukSpeech)"
      >
        英: {{ word.ukPhonetic }}
        <van-icon class="icon" name="volume-o" />
      </div>
      <div
        v-if="word.usSpeech"
        class="pronounce-btn"
        :class="{
          'pronounce-btn-sel': word.usSpeech && word.usSpeech == curAudioUrl,
        }"
        @click="action_pronounce(word.usSpeech)"
      >
        美: {{ word.usPhonetic }}
        <van-icon class="icon" name="volume-o" />
      </div>
    </div>
    <div class="word-explain">{{ explainWord }}</div>
    <!-- <van-divider class="line" />
    <van-button
      class="look-origin-btn"
      plain
      round
      type="info"
      @click="action_lookOriginArticle()"
      >点击查看原文>>
    </van-button> -->
  </div>
</template>

<script>
import { postAddWord, postRemoveWord, postRecoverWord } from "@/api/vocab";

export default {
  name: "WordbookCell",
  props: {
    curAudioUrl: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  computed: {
    btnword() {
      return this.item.isAddToNewWord ? "我掌握了" : "+ 生词本";
    },

    word() {
      return this.item.word || {};
    },
    wordName() {
      return this.item.wordName || this.item.word.wordName;
    },
    explainWord() {
      let wordExplain = "";
      if (this.item.explainCn) {
        return this.item.explainCn;
      }
      this.word.explains &&
        this.word.explains.forEach((item) => {
          wordExplain = `${wordExplain}${item}\n`;
        });
      return wordExplain;
    },
  },

  methods: {
    //点击+ 生词本/查看生词本
    action_newword() {
      if (this.item.isAddToNewWord) {
        //移除生词本
        this.request_postRemoveWord();
      } else {
        this.request_postRecoverWord();
      }
    },
    //点击发音
    action_pronounce(audioUrl) {
      //将要播放的url传递给外部的audio组件
      this.$emit("playAudio", audioUrl);
    },

    //点击查看原文
    action_lookOriginArticle() {
      this.$router.replace({
        path: "/articleDetail",
        query: {
          articleId: this.item.articleId,
          contentId: this.item.contentId,
        },
      });
    },

    //===============net======================
    //删除单词
    request_postRemoveWord() {
      postRemoveWord(this.item.userNewWordId).then((result) => {
        if (result.code === 0) {
          this.item.isAddToNewWord = false;
        } else {
          this.$toast(result.msg);
        }
      });
    },

    //添加单词
    request_postRecoverWord() {
      // let params = {
      //   contentId: this.item.contentId,
      //   wordId: this.item.word.wordId,
      //   wordName: this.item.word.wordName,
      // };
      postRecoverWord(this.item.userNewWordId).then((result) => {
        if (result.code === 0) {
          this.item.isAddToNewWord = true;
          this.$toast("添加成功");
        } else {
          this.$toast(result.msg);
        }
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../stylesheet/common.styl';

.word-container {
  margin: 10px auto;
  width: 90%;
  box-sizing: border-box;
  padding: 12px 12px;
  border-radius: 8px;
  background-color: #fff;

  .word-and-btn {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .word {
      font-size: 24px;
      font-weight: bold;
      flex: 1;
    }

    .new-word-btn {
      height: 26px;
      background-color: #fff;
      color: #000;
      border-color: #000;
      font-size: 13px;
    }

    .sel-new-word-btn {
      color: $common-blue;
      border-color: $common-blue;
    }
  }

  .pronounce-wrapper {
    display: flex;

    .pronounce-btn {
      margin-right: 12px;
      color: #5E616C;
      display: flex;
      align-items: center;

      .icon {
        margin-left: 6px;
      }
    }

    .pronounce-btn-sel {
      color: red;
    }
  }

  .word-explain {
    margin-top: 10px;
    white-space: pre-line;
  }

  .line {
    margin: 8px 0;
  }

  .look-origin-btn {
    border: none;
    height: 14px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// app/pages/tabs/NewWordBook/WordbookCell.vue